(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["header"]) return;
  try {
    
  class StickyHeader extends HTMLElement {
    constructor() {
      super();
      this.setHeaderHeight = this.setHeaderHeight.bind(this);
    }

    connectedCallback() {
      this.header = document.querySelector('.section-header');
      this.mobileMediaQuery = window.matchMedia('(max-width: 990px)');
      this.headerIsAlwaysSticky =
        this.getAttribute('data-sticky-type') === 'always' ||
        this.getAttribute('data-sticky-type') === 'reduce-logo-size';
      this.headerBounds = {};

      this.setHeaderHeight();

      this.mobileMediaQuery.addEventListener('change', this.setHeaderHeight);

      if (this.headerIsAlwaysSticky) {
        this.header.classList.add('shopify-section-header-sticky');
      }

      this.currentScrollTop = 0;
      this.preventReveal = false;
      this.predictiveSearches = this.querySelectorAll('predictive-search');

      this.onScrollHandler = this.onScroll.bind(this);
      this.hideHeaderOnScrollUp = () => (this.preventReveal = true);

      this.addEventListener('preventHeaderReveal', this.hideHeaderOnScrollUp);
      window.addEventListener('scroll', this.onScrollHandler, false);

      this.createObserver();
    }

    setHeaderHeight() {
      document.documentElement.style.setProperty('--header-height', `${this.header.offsetHeight}px`);
    }

    disconnectedCallback() {
      this.mobileMediaQuery.removeEventListener('change', this.setHeaderHeight);
      this.removeEventListener('preventHeaderReveal', this.hideHeaderOnScrollUp);
      window.removeEventListener('scroll', this.onScrollHandler);
    }

    createObserver() {
      let observer = new IntersectionObserver((entries, observer) => {
        this.headerBounds = entries[0].intersectionRect;
        observer.disconnect();
      });

      observer.observe(this.header);
    }

    onScroll() {
      const scrollTop = window.pageYOffset || document.documentElement.scrollTop;

      if ([...this.predictiveSearches].some((predictiveSearch) => predictiveSearch.isOpen)) return;

      if (scrollTop > this.currentScrollTop && scrollTop > this.headerBounds.bottom) {
        this.header.classList.add('scrolled-past-header');
        if (this.preventHide) return;
        requestAnimationFrame(this.hide.bind(this));
      } else if (scrollTop < this.currentScrollTop && scrollTop > this.headerBounds.bottom) {
        this.header.classList.add('scrolled-past-header');
        if (!this.preventReveal) {
          requestAnimationFrame(this.reveal.bind(this));
        } else {
          window.clearTimeout(this.isScrolling);

          this.isScrolling = setTimeout(() => {
            this.preventReveal = false;
          }, 66);

          requestAnimationFrame(this.hide.bind(this));
        }
      } else if (scrollTop <= this.headerBounds.top) {
        this.header.classList.remove('scrolled-past-header');
        requestAnimationFrame(this.reset.bind(this));
      }

      this.currentScrollTop = scrollTop;
    }

    hide() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.add('shopify-section-header-hidden', 'shopify-section-header-sticky');
      this.closeMenuDisclosure();
      this.closeSearchModal();
    }

    reveal() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.add('shopify-section-header-sticky', 'animate');
      this.header.classList.remove('shopify-section-header-hidden');
    }

    reset() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.remove('shopify-section-header-hidden', 'shopify-section-header-sticky', 'animate');
    }

    closeMenuDisclosure() {
      this.disclosures = this.disclosures || this.header.querySelectorAll('header-menu');
      this.disclosures.forEach((disclosure) => disclosure.close());
    }

    closeSearchModal() {
      this.searchModals = this.searchModals || this.header.querySelectorAll('details-modal');
      this.searchModals.forEach((searchModal) => searchModal.close(false));
    }
  }

  // The account `open` event is composed but does not bubble, so listen during capture.
  // Anchor the dialog to the bottom of the account button itself. The header group can be
  // much taller than the button's row (for example, a top-left logo pushes the menu to a
  // second row), so anchoring to the section bottom drops the dialog too low.
  document.addEventListener(
    'open',
    (event) => {
      if (!(event.target instanceof HTMLElement) || !event.target.matches('shopify-account')) return;

      const bottom = Math.max(0, Math.round(event.target.getBoundingClientRect().bottom));
      event.target.style.setProperty('--account-dialog-top', `${bottom}px`);
    },
    true
  );

  customElements.define('sticky-header', StickyHeader);

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["mellora-home"] && !Shopify.designMode) return;
  try {
    
  function initMelloraHome(root) {
    if (!root || root.dataset.melloraReady === 'true') return;
    root.dataset.melloraReady = 'true';
    root.querySelectorAll('.mh-carousel').forEach(function (carousel) {
      var track = carousel.querySelector('.mh-product-row');
      var previous = carousel.querySelector('.mh-carousel__button--prev');
      var next = carousel.querySelector('.mh-carousel__button--next');
      if (!track || !previous || !next) return;
      previous.addEventListener('click', function () { track.scrollBy({ left: track.clientWidth * -0.72, behavior: 'smooth' }); });
      next.addEventListener('click', function () { track.scrollBy({ left: track.clientWidth * 0.72, behavior: 'smooth' }); });
    });
    var buy = root.querySelector('.mh-featured__buy');
    if (buy) {
      var basePrice = Number(buy.dataset.basePrice || 0);
      var priceNode = buy.querySelector('[data-featured-price]');
      root.querySelectorAll('.mh-featured__option').forEach(function (option) {
        option.addEventListener('click', function () {
          root.querySelectorAll('.mh-featured__option').forEach(function (item) { item.classList.remove('is-active'); });
          option.classList.add('is-active');
          var quantity = Number(option.dataset.multiplier || 1);
          var discount = Number(option.dataset.discount || 0);
          var total = Math.round(basePrice * quantity * (100 - discount) / 100);
          priceNode.textContent = new Intl.NumberFormat('pt-BR', { style: 'currency', currency: 'BRL' }).format(total / 100);
        });
      });
    }
  }
  document.querySelectorAll('.mh').forEach(initMelloraHome);
  document.addEventListener('shopify:section:load', function (event) { initMelloraHome(event.target.querySelector('.mh')); });

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["mellora-kit-pdp"] && !Shopify.designMode) return;
  try {
    
function melloraKitGallery(root){if(!root)return;const main=root.querySelector('#mk-main-image');const composition=root.querySelector('#mk-composition');const buttons=root.querySelectorAll('[data-mk-image],[data-mk-kit]');buttons.forEach(button=>button.addEventListener('click',()=>{if(button.hasAttribute('data-mk-kit')){if(composition)composition.hidden=false;if(main)main.hidden=true}else if(main){main.src=button.dataset.mkImage;main.alt=button.dataset.mkAlt||'';main.hidden=false;if(composition)composition.hidden=true}buttons.forEach(item=>item.setAttribute('aria-current',String(item===button)))}))}document.querySelectorAll('.mk-page').forEach(melloraKitGallery);document.addEventListener('shopify:section:load',event=>melloraKitGallery(event.target.querySelector('.mk-page')));

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["mellora-product-carousel"] && !Shopify.designMode) return;
  try {
    
  function initMelloraCarousels(root){(root||document).querySelectorAll('[data-mh-carousel]').forEach(function(carousel){if(carousel.dataset.ready)return;carousel.dataset.ready='true';var track=carousel.querySelector('[data-mh-track]');var previous=carousel.querySelector('[data-mh-prev]');var next=carousel.querySelector('[data-mh-next]');function move(direction){var card=track.querySelector('.mh-product-card');var gap=parseFloat(getComputedStyle(track).gap)||0;var distance=card?card.getBoundingClientRect().width+gap:track.clientWidth*.8;track.scrollBy({left:direction*distance,behavior:'smooth'});}previous.addEventListener('click',function(event){event.preventDefault();move(-1)});next.addEventListener('click',function(event){event.preventDefault();move(1)});});}initMelloraCarousels(document);document.addEventListener('shopify:section:load',function(event){initMelloraCarousels(event.target)});

  } catch(e) { console.error(e); }
})();
})();
